import Vue from 'vue';
import App from '@/App.vue';
import './registerServiceWorker';
import router from '@/router';
import store from '@/store';

import 'amfe-flexible/index.js';
import 'vant/lib/index.css';
import '@/style/index.scss';
// 插件
import '@/plugins/app-axios';
import '@/plugins/dateformat';
import '@/plugins/element-plugin';

import vantPlugin from '@/plugins/vant-plugin';
Vue.use(vantPlugin);

import * as csrf from '@/plugins/xhr-csrf';
Vue.use(csrf, {
    beforeRequest(xhr: XMLHttpRequest) {
        if (store.state._csrf) {
            xhr.setRequestHeader('x-xsrf-token', store.state._csrf);
        }
    },
    afterResponse(xhr: XMLHttpRequest) {
        const token = xhr.getResponseHeader('x-xsrf-token');
        if (token != null) {
            store.commit('setSiteCSRF', token);
        }
    },
});

// 路由权限
import '@/router/permission';
store.dispatch('initState');
Vue.config.productionTip = false;
Vue.config.devtools = true

// 播放器
import VueVideoPlayer from 'vue-video-player';
import 'video.js/dist/video-js.css';
Vue.use(VueVideoPlayer);

new Vue({
    router,
    store,
    render: h => h(App),
}).$mount('#app');
